// articleSchema配下の各スキーマ項目が持つ duration (content.value.duration) を合算する。
// APIのレスポンスはスキーマ項目1件ごとに配列でラップされて返ってくるため、ネスト構造を問わず再帰的に走査する。
export const getTotalDuration = (articleSchema: unknown): number => {
    let total = 0;
    const walk = (node: unknown) => {
        if (Array.isArray(node)) {
            node.forEach(walk);
        } else if (node && typeof node === "object") {
            const duration = (node as any)?.content?.value?.duration;
            if (typeof duration === "number" && !isNaN(duration)) {
                total += duration;
            } else if (typeof duration === "string" && duration !== "" && !isNaN(Number(duration))) {
                total += Number(duration);
            }
        }
    };
    walk(articleSchema);
    return Math.ceil(total);
};
